module.exports = __webpack_public_path__ + "img/4-2.71cb0824.png";